import './App.css?v=5';
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import SitePet from "./SitePet";
import Sidebar from './SideBar.js'; 
import ProjectSection from './ProjectCard.js';
import PortfolioFooter from './PortfolioFooter.js';

function AllProjects() {

  return ( 
    <div className="">
      <div className="screen-1">
          <Sidebar />

          <div className="content-1">
            <ProjectSection filter="all" />
          </div>
        </div>
                  <div
        className="frame6"
        data-platform
        data-pet-message="Contact zone reached. I will wave politely."
      >
        <PortfolioFooter />
      </div>
      <SitePet />
    </div>
  );
}

export default AllProjects;
